// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"61dff1b8","496":"6456c976","703":"5dfab4be"}[chunkId] + ".chunk.js";
};